<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "personel"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/personel.vue